module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/72230a3d8ba1bd5c74d444a6ac20edf9.svg";